import React, { useState, useEffect } from 'react';
import { navigate } from '../Router';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import './Gallery.css';

const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // All WhatsApp images
  const allImages = [
    '/images/WhatsApp Image 2026-01-13 at 8.04.02 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.02 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.02 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.03 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.03 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.03 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.04 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.04 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.04 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.05 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.05 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.05 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.06 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.06 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.07 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.07 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.07 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.08 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.08 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.09 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.09 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.09 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.10 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.10 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.10 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.11 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.11 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.11 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.12 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.12 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.12 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.13 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.13 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.13 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.14 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.14 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.14 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.15 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.15 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.16 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.16 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.16 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.17 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.17 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.17 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.18 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.18 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.18 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.19 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.19 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.19 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.20 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.20 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.20 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.21 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.21 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.21 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.22 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.22 PM-2.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.22 PM-3.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.23 PM.jpeg',
    '/images/WhatsApp Image 2026-01-13 at 8.04.23 PM-2.jpeg',
  ];

  const footerData = {
    hotels: [
      { label: 'The Jaipur Hotels', url: '/#home' },
      { label: 'About Us', url: '/#about' },
      { label: 'Rooms & Suites', url: '/#rooms' },
      { label: 'Dining', url: '/#dining' },
    ],
    residences: [
      { label: 'Services & Facilities', url: '/#services' },
      { label: 'Nearby Attractions', url: '/#attractions' },
    ],
    mediaAndSales: {
      title: 'Quick Links',
      links: [
        { label: 'Home', url: '/', external: false },
        { label: 'Gallery', url: '/gallery', external: false },
        { label: 'Rooms', url: '/#rooms', external: false },
        { label: 'Contact', url: '/#contact' },
      ],
    },
    getToKnowUs: {
      title: 'Get to know us',
      links: [
        { label: 'About The Jaipur Hotels', url: '/#about' },
        { label: 'Our Heritage', url: '/#about' },
        { label: 'Location & Directions', url: '/#contact' },
        { label: 'Booking Terms', url: '#' },
      ],
    },
    socialMedia: [
      { platform: 'instagram', url: '#' },
      { platform: 'facebook', url: '#' },
      { platform: 'twitter', url: '#' },
    ],
    giftsLink: {
      label: 'Attractions',
      url: '/#attractions',
      external: false,
    },
    contactLink: {
      label: 'Contact',
      url: '/#contact',
    },
    disclaimerLeft: `The Jaipur Hotels
Plot No 66 A, RPA Road
Sanjay Colony, Nehru Nagar
Jaipur, Rajasthan 302016, India`,
    disclaimerRight: `Jivrajsinghrajawat@gmail.com
Phone: +91 9982226444
24/7 Front Desk Service`,
    legalLinks: [
      { label: 'Privacy policy', url: '#' },
      { label: 'Terms of use', url: '#' },
      { label: 'Booking terms', url: '#' },
    ],
    copyrightText: '© 2025 The Jaipur Hotels. All Rights Reserved.',
    developerCredit: {
      text: '© 2025 Developed by Dizital Junction',
      url: 'https://dizitaljunction.com'
    }
  };

  return (
    <div className="gallery-page">
      <Header />

      <div className="gallery-hero">
        <div className="gallery-hero-overlay">
          <h1>Photo Gallery</h1>
          <p>Explore The Jaipur Hotels and the beautiful Pink City</p>
          <button onClick={() => navigate('/')} className="back-home-link">
            ← Back to Home
          </button>
        </div>
      </div>

      <section className="full-gallery-section">
        <div className="full-gallery-container">
          <div className="gallery-stats">
            <p>{allImages.length} Photos</p>
          </div>

          <div className="full-gallery-grid">
            {allImages.map((image, index) => (
              <div
                key={index}
                className="full-gallery-item"
                onClick={() => setSelectedImage(image)}
              >
                <div className="full-gallery-image-wrapper">
                  <img
                    src={image}
                    alt={`The Jaipur Hotels Gallery ${index + 1}`}
                    loading="lazy"
                  />
                  <div className="full-gallery-overlay">
                    <span className="view-icon">🔍</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="lightbox-close"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
            <img src={selectedImage} alt="Gallery lightbox" />
          </div>
        </div>
      )}

      <Footer
        {...footerData}
        signUpText=""
        signUpButtonText=""
        signUpButtonLink=""
      />

      <FloatingWhatsApp />
    </div>
  );
};

export default Gallery;
